module.exports = __webpack_public_path__ + "e05327578e6278c918412e64a9688f21.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center/info-sharing-center-zh.html
// module id = 945
// module chunks = 0